/**
 * Brand assets. `LogoImage` renders the real EFTCreator wordmark PNG; `Spiral` is the logo's
 * fingerprint-spiral mark rebuilt as an SVG (for badges, favicons, and decorative motifs).
 */
// Served from web/public at the site root by Vite.
const LOGO_URL = '/eftcreator-logo.png';

export function LogoImage({ height = 30, className }: { height?: number; className?: string }) {
  return (
    <img
      src={LOGO_URL}
      alt="EFTCreator"
      height={height}
      style={{ height, width: 'auto', display: 'block' }}
      {...(className ? { className } : {})}
    />
  );
}

function spiralPath(cx: number, cy: number, turns: number, spacing: number, start: number): string {
  const steps = Math.round(turns * 48);
  const pts: string[] = [];
  for (let i = 0; i <= steps; i++) {
    const t = (i / steps) * turns * 2 * Math.PI;
    const r = start + spacing * t;
    pts.push(`${(cx + r * Math.cos(t)).toFixed(2)},${(cy + r * Math.sin(t)).toFixed(2)}`);
  }
  return 'M' + pts.join(' L');
}

/** The logo's spiral mark. Defaults to brand green; pass color to override (e.g. dark ink on a green chip). */
export function Spiral({ size = 28, color = 'var(--accent)', stroke = 2.4 }: { size?: number; color?: string; stroke?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" aria-hidden style={{ overflow: 'hidden' }}>
      <path d={spiralPath(20, 20, 3.4, 1.6, 1.4)} fill="none" stroke={color} strokeWidth={stroke} strokeLinecap="round" />
    </svg>
  );
}

/** Compact square badge: the spiral on a brand-green chip (for tight spaces / app bar). */
export function LogoBadge({ size = 32 }: { size?: number }) {
  return (
    <span
      className="brand-mark"
      style={{ width: size, height: size, display: 'grid', placeItems: 'center' }}
      aria-hidden
    >
      <Spiral size={size * 0.66} color="var(--accent-ink)" stroke={2.6} />
    </span>
  );
}
